import { TransportMode } from '../open-trip-planner';

export interface SearchResult {
    stopRoutes: StopRouteResult[];
    addresses: AddressResult[];
    poi: AddressResult[] | PoiResult[];
}

export interface StopRouteResult {
    id: string;
    type: TransitNetworkPartType;
    name: string;
    desc?: string;
    shortName?: string;
    code?: string;
    mode?: TransportMode;
    color?: string;
}

export interface AddressResult {
    id: string;
    name: string;
    address: string;
    lon: number;
    desc?: string;
    color?: string;
    shortName?: string;
    lat: number;
    type: TransitNetworkPartType;
}

export interface PoiAddressResponse {
    data?: PoiAddressResult[];
}
export interface PoiAddressResult {
    id: number;
    address: string;
    name?: string;
    desc?: string;
    color?: string;
    shortName?: string;
    postcode: string;
    type: string;
    lat: number;
    lon: number;
    geometry?: number[];
    poi_id: number;
    poi_name?: string;
}

export interface PoiResult {
    id: number;
    address: string;
    name?: string;
    color?: string;
    shortName?: string;
    postcode: string;
    type: string;
    lat: number;
    lon: number;
    geometry?: number[];
    poi_id: number;
    poi_name?: string;
}

export enum TransitNetworkPartType {
    Stop = 'STOP',
    Route = 'ROUTE',
    Location = 'LOCATION',
    POI = 'POI'
}
